import { render } from "./forgot-reset-password.vue?vue&type=template&id=76c04fda"
import script from "./forgot-reset-password.vue?vue&type=script&lang=js"
export * from "./forgot-reset-password.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__